import React from "react";

const CommentIcon = ({ width = 28, height = 12, fill = "#F66", stroke = "#F66", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="-21 -47 682.667 682"
      fill={fill}
      stroke={stroke}
      strokeWidth={30}
      {...props}
    >
      <path d="M552.012-1.332H87.988C39.473-1.332 0 38.133 0 86.656V370.63c0 48.414 39.3 87.816 87.676 87.988V587.48l185.191-128.863h279.145c48.515 0 87.988-39.472 87.988-87.988V86.656c0-48.523-39.473-87.988-87.988-87.988zm50.488 371.96c0 27.837-22.648 50.49-50.488 50.49h-290.91l-135.926 94.585v-94.586H87.988c-27.84 0-50.488-22.652-50.488-50.488V86.656c0-27.843 22.648-50.488 50.488-50.488h464.024c27.84 0 50.488 22.645 50.488 50.488zm0 0" />
    </svg>
  );
};

export default CommentIcon;
